import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { HttpService } from 'src/service/http.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  model: any = {};
  fieldTextType: boolean;
  isCollapsed = true;
  email:any;
  constructor(
    private router: Router,
    private httpService:HttpService,
    private authGuard:AuthGuard
  ) { 
    localStorage.clear();
    this.authGuard.checkIdStatus();
  }

  ngOnInit(): void {
    if (localStorage.getItem('accessToken')) {
      this.router.navigate(['/']);
    }

  }

  onSignIn(form: NgForm) {
    if (form.valid) {
      var forgotObj={
        email:form.value.email
      }
      this.email=form.value.email;
      this.httpService.forgotPassword(forgotObj).subscribe(result => {
        //
        localStorage.setItem('token',result['responseData'].otp_tokenId);
        localStorage.setItem('email',this.email);
        localStorage.setItem('otp_status','forgot');

        if (result.responseCode === 0) {
          Swal.fire({
            html: `<h6 class="head">OTP has been sent to your email<h6><h5 class="sub-head">${this.email}</h5>`,
            icon: 'success',
            confirmButtonText: 'OK',
                customClass: {
                  container: 'my-swal',
                  confirmButton: 'your-confirm-button-class',
                }
          }).then((result) => {
            this.router.navigate(['otp','1'])
          });
        }
        else {
          //alert("Invalid Credentials!")
          Swal.fire({
            html: `<h6 class="head">Error!<h6><h5 class="sub-head">${result.responseData}</h5>`,
            icon: 'error',
            confirmButtonText: 'OK',
                customClass: {
                  container: 'my-swal',
                  confirmButton: 'your-confirm-button-class',

                }
          }).then((result) => {
          });
        }
  
      }, err => {
       // console.log(err)
        Swal.fire({
          html: '<h6 class="head">Error!<h6><h5 class="sub-head">'+ err.error.message+'</h5>',
          icon: 'error',
          confirmButtonText: 'OK',
              customClass: {
                container: 'my-swal',
                confirmButton: 'your-confirm-button-class',

              }
        }).then((result) => {
        });
      })
    }
  }
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  goToSignUp(){
    this.router.navigate(['/'])
  }
}



